import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import logo from '../../assets/tx-logo.png';

/**
 * The TrialX logo with "Social" in a pill fitted under TRIAL, beside the X's tail: in the image TRIAL is the top 56%
 * and left 69%, and the tail reaches the bottom. Everything scales with `height` (px, or responsive like
 * { xs: 56, md: 64 }); below about 40px the pill's text gets too small to read.
 */
export default function BrandLockup({ height }) {
  const heights = typeof height === 'object' ? height : { xs: height };
  const logoHeight = Object.fromEntries(Object.entries(heights).map(([key, px]) => [key, `${px}px`]));

  return (
    <Box sx={(theme) => ({
      '--logo-h': logoHeight, position: 'relative', display: 'inline-flex', flexShrink: 0,
      '& .brand-pill': {
        position: 'absolute', left: '1%', width: '67%', top: '66%', bottom: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
        borderRadius: 999, fontWeight: 700, lineHeight: 1, whiteSpace: 'nowrap',
        fontSize: 'calc(var(--logo-h) * 0.19)', letterSpacing: '0.5em',
        // letter-spacing trails the last letter; indent the same so the word stays centred
        textIndent: '0.5em', textTransform: 'uppercase', color: 'primary.main',
        bgcolor: alpha(theme.palette.primary.main, 0.06),
        border: `1.5px solid ${alpha(theme.palette.primary.main, 0.25)}`,
      },
    })}>
      <Box component="img" src={logo} alt="TrialX"
           sx={{ height: 'var(--logo-h)', width: 'auto', display: 'block' }} />
      <Box component="span" className="brand-pill">Social</Box>
    </Box>
  );
}
